import {createContext} from 'react';

const ProjectCustomMappingsContext = createContext(null);

export default ProjectCustomMappingsContext;
